<template>
  <div class="TestQuestionList">
    <div class="tableFilter">

      <el-form :inline="true" :model="filter" size="small" ref="form">
        <el-form-item label="所属试卷">
          <el-select
              style="width: 150px"
              v-model="filter.testPaperId"
              v-scroll="loadMoreTestPaper"
              placeholder="请选择"
              @change="onSubmit"
          >
            <el-option
                v-for="item in testPaperSelection"
                :key="item.id"
                :label="item.name"
                :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="试题类型">
          <el-select
              style="width: 150px"
              v-model="filter.type"
              placeholder="请选择"
              @change="onSubmit"
          >
            <el-option
                v-for="item in questionType"
                :key="item.id"
                :label="item.name"
                :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
              v-model="filter.keyword"
              placeholder="试题名称"
              @keyup.enter.native="onSubmit"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查找</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
      <div style="text-align: right">
        <el-button
            :disabled="!filter.testPaperId"
            type="primary"
            native-type="submit"
            plain
            @click="openQuestionSelect"
            v-show="permissionCode.has('plugin:testPaper:manager')"
        >添加题目
        </el-button>
        <el-button
            type="primary"
            native-type="submit"
            plain
            @click="openAddQuestion"
            v-show="permissionCode.has('plugin:testPaper:manager')"
        >新增题目
        </el-button>
      </div>
    </div>
    <XTable
        :api="getTestQuestionList"
        :state="testQuestionList"
        :columns="columns"
        :loading="testQuestionListLoading"
        :tableSize="tableSize"
        :firstColumn="firstColumn"
        :layout="layout"
        :max-height="maxHeight"
    ></XTable>
    <AddQuestionModal ref="questionEditor"></AddQuestionModal>
    <question-list-modal @selectConfirm="selectConfirm" ref="questionListModal"></question-list-modal>
  </div>
</template>

<script>
import XTable from "@/components/XTable/index.vue";
import {mapActions, mapMutations, mapState} from "vuex";
import {SUBJECT_TYPE} from "@/utils/constants";
import AddQuestionModal from "@/pages/QuestionBank/AddQuestionModal.vue";
import QuestionListModal from "@/pages/QuestionBank/QuestionListModal.vue";

export default {
  name: "TestQuestionList",
  components: {QuestionListModal, AddQuestionModal, XTable},
  props: {
    maxHeight: {
      type: Number,
      default() {
        return null;
      },
    },
  },
  computed: {
    ...mapState("user", ["permissionCode"]),
    ...mapState("pluginCenter", ["testQuestionList", "testQuestionListLoading", "testPaperMapList"]),
    columns: function () {
      const self = this;
      let canEdite = this.permissionCode.has('plugin:testPaper:manager');
      const columns = [
        {
          prop: "content.title",
          label: "题目",
        },
        {
          label: "题目类型",
          width: 120,
          render(h, scope) {
            return (
                <div>
                  <span>{SUBJECT_TYPE[scope.row.content.type]}</span>
                </div>
            );
          },
        },
      ];

      if (canEdite) {
        let canDelete = !self.filter.testPaperId;
        columns.push({
          label: "调整顺序",
          width: 150,
          render(h, scope) {
            if (scope.row.noEdit)
              return null;
            return (
                <div>
                  <el-button
                      onClick={() => {
                        self.handleUp(scope);
                      }}
                      disabled={(self.isUp && scope.$index === 0) || self.filter.testPaperId === null}
                      size="mini"
                      type="primary"
                      plain
                  >
                    上移
                  </el-button>
                  <el-button
                      onClick={() => {
                        self.handleDown(scope);
                      }}
                      disabled={(self.isDown == scope.$index) || self.filter.testPaperId === null}
                      size="mini"
                      type="primary"
                      plain
                  >
                    下移
                  </el-button>
                </div>
            );
          },
        })
        columns.push({
          label: "操作",
          fixed: "right",
          width: 150,
          render(h, scope) {
            if (scope.row.noEdit)
              return null;
            return (
                <div>
                  <el-button
                      onClick={() => {
                        self.openEditQuestion(scope.row);
                      }}
                      size="mini"
                      type="primary"
                      plain
                  >
                    编辑
                  </el-button>
                  <el-button
                      disabled={canDelete}
                      onClick={() => {
                        self.handleDelete(scope.row);
                      }}
                      size="mini"
                      type="danger"
                      plain
                  >
                    删除
                  </el-button>
                </div>
            );
          },
        });
      }
      return columns;
    },
    filter: {
      get() {
        return this.$store.state.pluginCenter.testQuestionListFilter;
      },
      set(value) {
        this.$store.commit("pluginCenter/setData", {
          key: "testQuestionListFilter",
          value,
        });
      },
    },
    isUp() {
      return this.testQuestionList.page === 1;
    },
    isDown() {
      return this.testQuestionList.total - (this.testQuestionList.page - 1) * this.testQuestionList.size - 1;
    },
  },
  data() {
    let questionType = [
      {
        id: null,
        name: "全部"
      },
      {
        id: "select",
        name: "单选题"
      },
      {
        id: "judge",
        name: "判断题"
      },
      {
        id: "multipleSelect",
        name: "多选题"
      }
    ]
    return {
      tableSize: "small",
      layout: "sizes, prev, pager, next",
      firstColumn: true,
      testPaperSelection: [],
      questionType: questionType,
    }
  },
  async mounted() {
    await this.getTestPaperMapList({});
    this.testPaperSelection = this.testPaperSelection.concat(this.testPaperMapList.data);
  },
  methods: {
    ...mapActions("pluginCenter", ["getTestQuestionList", "getTestPaperMapList", "moveTestQuestion",
      "deleteTestPaperQuestion", "saveTestPaperQuestion"]),
    ...mapMutations("pluginCenter", ["setData"]),
    async selectConfirm(row) {
      if (!row.length) return;
      let ids = row.map(item => item.id);
      let res = await this.saveTestPaperQuestion({testPaperId: this.filter.testPaperId, testQuestionIds: ids});
      this.$message.success("添加题目成功")
      await this.getTestQuestionList({});
    },
    openQuestionSelect() {
      this.$refs.questionListModal.openQuestionSelectList(this.filter.testPaperId);
    },
    openAddQuestion() {
      this.openEditQuestion();
    },
    openEditQuestion(row) {
      if (row) {
        row.testPaperId = this.filter.testPaperId;
      }
      this.$refs.questionEditor.initFormData(this.filter.testPaperId, row);

      this.setData({
        key: "addQuestionModalVisible",
        value: true,
      });
    },
    handleDelete(row) {
      this.$confirm("请确认是否要删除改试题!", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        await this.deleteTestPaperQuestion({
          id: row.id,
          testPaperId: this.filter.testPaperId
        });
        await this.getTestQuestionList({});
        this.$message.success("删除成功");
      })
    },
    // 上移
    async handleUp(scope) {
      await this.moveFun(true, scope);
    },
    // 下移
    async handleDown(scope) {
      await this.moveFun(false, scope);
    },
    // 移动方法
    async moveFun(previewDirect, scope) {
      const offset = (this.testQuestionList.page - 1) * this.testQuestionList.size + scope.$index + 1;
      await this.moveTestQuestion({
        offset: offset,
        previewDirect: previewDirect,
        step: 1,
      }).then(() => {
        this.getTestQuestionList({})
      });
    },
    async loadMoreTestPaper() {
      const currentPage = this.testPaperMapList.page;
      const currentSize = this.testPaperMapList.size;
      const currentTotal = this.testPaperMapList.total;
      if (currentPage * currentSize < currentTotal) {
        await this.getTestPaperMapList({
          page: this.testPaperMapList.page + 1,
        });
        this.testPaperSelection = this.testPaperSelection.concat(this.testPaperMapList.data);
      }
    },
    async onSubmit() {
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.getTestQuestionList({
            ...this.filter,
            page: 1,
          });
        }
      });
    },
    async onReset() {
      this.filter = {};
      await this.getTestQuestionList({
        page: 1,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.TestQuestionList {
  .tableFilter {
    padding-top: 20px;
    padding-bottom: 20px;

    .el-form-item {
      margin-right: 30px;
    }

    ::v-deep .el-range-separator {
      width: 20px !important;
    }
  }
}
</style>
